import {createStore, applyMiddleware, compose} from 'redux'
import {connectRouter, routerMiddleware} from 'connected-react-router'
import thunk from 'redux-thunk'
import {createBrowserHistory} from 'history'
import rootReducer from './Redux'
import {updateLastActive} from "./Containers/Identify/Actions";
import {Analytics} from "./Common/Analytics";
import {resetWizard} from "./Containers/Welcome/Actions";

export const history = createBrowserHistory();

const UPDATE_LAST_ACTIVITY = 5; // seconds.
const REFRESH_IF_IN_ACTIVE_FOR = 60 * 30; // 30 Minutes.

function logger({getState}) {
    return next => action => {
        // Call the next dispatch method in the middleware chain.
        const returnValue = next(action);

        setTimeout(() => {
            const timeDiff = new Date() - getState().identify.lastActivity;
            if (timeDiff > REFRESH_IF_IN_ACTIVE_FOR * 1000) {
                Analytics.track(`auto-refresh-page`, {timeDiff});
                setTimeout(() => {
                    resetWizard();
                }, 300);

            }

            if (timeDiff > UPDATE_LAST_ACTIVITY * 1000) {
                next(updateLastActive(new Date()));
            }
        });

        return returnValue
    }
}

const initialState = {};
const enhancers = [];
const middleware = [
    thunk,
    logger,
    routerMiddleware(history)
];

if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.devToolsExtension;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

const store = createStore(
    connectRouter(history)(rootReducer), // new root reducer with router state
    initialState,
    composedEnhancers
);

export const getStateParams = () => {
    let stateParams = store.getState().schedule.stateParams;
    stateParams = stateParams && stateParams.asMutable() || {};
    return stateParams;
};

export const getUserSelection = () => {
    const selection = store.getState().schedule.userSelection || {asMutable: () => ({})};
    return selection.asMutable();
};

export const getProgressValues = () => {
    return store.getState().schedule.progress.asMutable();
}

export const resetWizardToBeginning = () => {
    store.dispatch(resetWizard());
}

export const getMeetingsToReplace = () => {
    const schedule = store.getState().schedule;

    if (!schedule.existingMode) {
        return null;
    }

    return schedule.existingMode;
}


export default store
